import { UpdateCardInput, Operation } from '../../../__generated__/globalTypes'

import {
  CardFragment,
  cardFragmentString,
} from '../../fragments/__generated__/CardFragment'

import { sendableCardFragmentString } from '../../fragments/__generated__/SendableCardFragment'

import { priceString } from '../../fragments/__generated__/Price'

import { imageFragmentString } from '../../fragments/__generated__/ImageFragment'

import { elementFragmentString } from '../../fragments/__generated__/ElementFragment'

import { textFragmentFragmentString } from '../../fragments/__generated__/TextFragmentFragment'

import { elementPictureFragmentString } from '../../fragments/__generated__/ElementPictureFragment'

import { panelFragmentString } from '../../fragments/__generated__/PanelFragment'

import { labeledPriceString } from '../../fragments/__generated__/LabeledPrice'

import { sendableCardImageFragmentString } from '../../fragments/__generated__/SendableCardImageFragment'

import { elementTextFragmentString } from '../../fragments/__generated__/ElementTextFragment'

import { paragraphFragmentString } from '../../fragments/__generated__/ParagraphFragment'

import { colorFragmentString } from '../../fragments/__generated__/ColorFragment'

import { itemizedCostFragmentString } from '../../fragments/__generated__/ItemizedCostFragment'

import { sendableCardWithTemplateFragmentString } from '../../fragments/__generated__/SendableCardWithTemplateFragment'

import updateCardRawString from '../UpdateCard.graphql'

const updateCardString = [
  updateCardRawString,
  cardFragmentString,
  sendableCardFragmentString,
  priceString,
  imageFragmentString,
  elementFragmentString,
  textFragmentFragmentString,
  elementPictureFragmentString,
  panelFragmentString,
  labeledPriceString,
  sendableCardImageFragmentString,
  elementTextFragmentString,
  paragraphFragmentString,
  colorFragmentString,
  itemizedCostFragmentString,
  sendableCardWithTemplateFragmentString,
].join('\n\n')

export type UpdateCardData = {
  updateCard: {
    card: CardFragment
  }
}

export type UpdateCardVariables = {
  card: UpdateCardInput
}

export type UpdateCard = Operation<UpdateCardData, UpdateCardVariables>

export const UpdateCard = ({ card }: UpdateCardVariables): UpdateCard => ({
  query: updateCardString,
  variables: {
    card: UpdateCardInput(card),
  },
})
